import { format, isValid, parseISO } from "date-fns";

export interface ReviewPromotionRange {
  startDate: string;
  endDate: string;
}

export type ReviewScheduleError =
  | "invalid"
  | "past"
  | "beforeStart"
  | "promotionOutside"
  | "promotionExpired";

/** Review API validates Campaign dates against the current UTC calendar day. */
export function reviewScheduleToday(now: Date): string {
  return now.toISOString().slice(0, 10);
}

export function scheduleDate(value: string): Date | undefined {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return undefined;
  const parsed = parseISO(value);
  return isValid(parsed) && format(parsed, "yyyy-MM-dd") === value ? parsed : undefined;
}

/** The review editor must reject a bad schedule before persisting it, not at final confirmation. */
export function validateReviewSchedule(
  start: string,
  end: string,
  today: string,
  promotion: ReviewPromotionRange | null,
): { start: ReviewScheduleError | null; end: ReviewScheduleError | null } {
  const startError =
    promotion && promotion.endDate < today
      ? "promotionExpired"
      : !scheduleDate(start)
        ? "invalid"
        : start < today
          ? "past"
          : promotion && start > promotion.startDate
            ? "promotionOutside"
            : null;
  const endError = !end
    ? null
    : !scheduleDate(end)
      ? "invalid"
      : end < start
        ? "beforeStart"
        : promotion && end < promotion.endDate
          ? "promotionOutside"
          : null;
  return { start: startError, end: endError };
}
